<template>
  <div>
    <div class="home-content">
      <div class="display-1 font-weight-bold">Hello!</div>
      <p>This is where I'll be hosting the results and updates for my ray tracer, as part of the CSCI-711 course at RIT!</p>
      <p>Check out my latest update here:</p>
      <update-card :storeIndex="latest" style="max-width: 600px; margin: auto;"/>
    </div>
  </div>
</template>

<script>
import UpdateCard from '../components/UpdateCard';

export default {
  name: 'home',
  components: {
    UpdateCard,
  },
  data() {
    return {};
  },
  computed: {
    latest() {
      return this.$store.state.updates.length - 1;
    }
  },
};
</script>


<style>
.home-content {
  margin: 25px 20% 0 20%;
  text-align: center;
}

@media only screen and (max-width: 729px) {
  .home-content {
    margin: 25px 5px 0 5px;
    text-align: center;
  }
}
</style>
